import * as jsonld from "jsonld";
import { parseRdfQuadsWithN3 } from "../n3/n3-adapter.js";
export async function parseRdfQuadsWithJsonLd(content) {
    const contentAsJson = JSON.parse(content);
    const options = {
        format: "application/n-quads",
        documentLoader: async (url) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const loader = jsonld.documentLoaders.node();
            // Encode the URL to allow for national characters.
            return await loader(encodeURI(url));
        },
    };
    const nquads = await jsonld.toRDF(contentAsJson, options);
    if (typeof nquads !== "string") {
        throw new Error("Expected JSON-LD conversion to produce N-Quads.");
    }
    return parseRdfQuadsWithN3(nquads);
}
//# sourceMappingURL=jsonld-adapter.js.map